var _path, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSuspicious = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 100,
  height: 100,
  viewBox: "0 0 100 100",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M61.5 11H34.2C27.8294 11 24.6441 11 22.2109 12.2398C20.0705 13.3304 18.3304 15.0705 17.2398 17.2109C16 19.6441 16 22.8294 16 29.2V70.8C16 77.1706 16 80.3559 17.2398 82.7891C18.3304 84.9295 20.0705 86.6696 22.2109 87.7602C24.6441 89 27.8294 89 34.2 89H66.05C72.4206 89 75.6059 89 78.0391 87.7602C80.1795 86.6696 81.9196 84.9295 83.0102 82.7891C84.25 80.3559 84.25 77.1706 84.25 70.8V33.75H68C64.4101 33.75 61.5 30.8399 61.5 27.25V11Z",
  fill: "#FF9E00"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 6.5,
  height: 13,
  rx: 1.625,
  transform: "matrix(-1 0 0 1 53.375 41.875)",
  fill: "white"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 6.5,
  height: 6.5,
  rx: 1.625,
  transform: "matrix(-1 0 0 1 53.375 58.125)",
  fill: "white"
})));
export { SvgSuspicious as ReactComponent };